import axios from "axios";
import apiMixins from "@/mixins/apiMixins";

export default {
	mixins: [apiMixins],
	methods: {
		/* checa se a url é uma url do youtube valida */
		checkUrlIsVideoOfYoutube: function(url) {
			const matchShortLink = url.match(/(youtu\.be)/g);
        	const matchLongLink = url.match(/(watch\?v=)/g);

			return matchShortLink !== null || matchLongLink !== null ? true : false;
		},
		/* retorna o conteudo do frame para adicionar */
		getContentOfEmbedYoutube: async function(event, siteId, postId) {
			const matchShortLink = event.match(/(youtu\.be)/g);
        	const matchLongLink = event.match(/(watch\?v=)/g);

			if (matchShortLink && matchLongLink) {
	            event = event.replace("youtu.be", "");
	            event = event.replace("watch?v=", "embed/");
	            event = event.split("&")[0];
	        }

	        if (event.slice(0, 8) !== "https://") {
	            if (event.slice(0, 7) === "http://") {
	              event = event.replace("http://", "https://");
	            } else {
	              event = "https://" + event;
	            }
	        }

	        const uri = { uri: event };
	        const url = `/site/${siteId}/post/${postId}/video/link`;

          	return await this.requestApiData(url, "post", uri);
		},
		/* checa a url se tem que dar replace no embed */
		checkReplaceEmbedIfYoutube(url) {
			if (this.checkUrlIsVideoOfYoutube(url)) {
				const matchShortLink = url.match(/(youtu\.be)/g);

				return matchShortLink !== null
	                ? url.replace("youtu.be", "youtube.com/embed")
	                : url.replace("watch?v=", "embed/")
			} else {
				return url
			}
		}
	}

}


// WEBPACK FOOTER //
// ./src/mixins/youtubeMixins.js